import Banner from '../../components/Banner/Banner'
import Features from '../../components/Features/Features'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import HowItWorks from '../../components/HowItWorks/HowItWorks'
import Solutions from '../../components/Solutions/Solutions'
import SubscriptionPlan from '../../components/SubscriptionPlan/SubscriptionPlan'
import './Home.css'

function Home() {
  return (
    <div className='Home'>
        <Banner />
        <Features />
        <HowItWorks />
        <Solutions />
        <SubscriptionPlan />
        <Footer />
    </div>
  )
}

export default Home